import { useMutation } from "@shared/lib/hooks";
import { DeliverableConfiguratorService } from "../services/deliverable.configurator.service";

import { DELIVERABLE_CONFIGURATOR_SYNC_MEDIA_RIGHTS_QUERY_KEY } from "../constants";

export default function useSyncMediaRights() {
  const {
    mutate: syncMediaRights,
    isLoading: isSyncMediaRightsLoading,
    error: syncMediaRightsError,
    isSuccess: isSyncMediaRightsSuccess,
  } = useMutation({
    mutationFn: (
      data: {
        name: string;
        description: string;
      }[]
    ) => DeliverableConfiguratorService.syncMediaRights(data),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...DELIVERABLE_CONFIGURATOR_SYNC_MEDIA_RIGHTS_QUERY_KEY],
      });
    },
  });

  return {
    syncMediaRights,
    isSyncMediaRightsLoading,
    isSyncMediaRightsSuccess,
    syncMediaRightsError,
  };
}
